<template>
  <div class="account-details">
    <div class="balance" v-if="loader">
      <p class="centered">Loading...</p>
    </div>
    <div class="balance" v-else>
      <div class="main-row">
        <div class="main-bal">
          <p>Account Balance</p>

          <h6 v-if="manageAccess.accountBalance">
            {{amountFormat(getterAccountBalance)}}
          </h6>
          <div v-else class="info">
            <i class="fa fa-lock" />
            <strong>
              Access Denied
              <i class="fa fa-info-circle">
                <md-tooltip md-direction="top">Please contact your admin to get access to this section</md-tooltip>
              </i>
            </strong>
          </div>
        </div>

        <div v-if="selfVa.enabled">
          <div class="main-bal">
            <p>VA Balance
              <i class="fa fa-info-circle">
                <md-tooltip md-direction="top">Total Balance held by Virtual Accounts</md-tooltip>
              </i>
            </p>

            <h6 v-if="manageAccess.vaBalance">
              {{amountFormat(selfVa.balance)}}
            </h6>
            <div v-else class="info">
              <i class="fa fa-lock" />
              <strong>
                Access Denied
                <i class="fa fa-info-circle">
                  <md-tooltip md-direction="top">Please contact your admin to get access to this section</md-tooltip>
                </i>
              </strong>
            </div>
          </div>
        </div>

        <div v-if="manageAccess.lienAmount && lienAmount">
          <div class="main-bal">
            <p>Lien Amount
              <i class="fa fa-info-circle">
                <md-tooltip md-direction="top">Lien Amount marked by Hypto</md-tooltip>
              </i>
            </p>

            <h6>
              {{amountFormat(lienAmount)}}
            </h6>
          </div>
        </div>
      </div>

      <div class="options">
        <button v-if="manageAccess.connectedBankingBal.icici" @click="connectedBankBalance"
                class="connected-bank xl outline-btn">
          <i class="fa fa-university" />
          Connected Bank Balance
        </button>
        <button @click="openPopup('AddFunds')" v-if="manageAccess.accountDetails"
          class="outline-btn">
          <span class="fa fa-plus" />
          Add Funds
        </button>
        <button @click="openPopup('Verifications')" class="xl primary-btn"
                v-if="manageAccess.bankVerify || manageAccess.upiVerify">
          <span class="fa fa-university" />
          {{manageAccess | verifyText}}
        </button>
        <button @click="openPopup('BankTransfer')" v-if="manageAccess.fundTransfer"
          class="primary-btn">
          <span class="fa fa-exchange-alt" />
          Bank Transfer
        </button>
      </div>
    </div>

    <div class="details" v-if="loader">
      <p class="centered">Loading...</p>
    </div>
    <div class="details" v-else>
      <p>Transfer funds to the following account to use Hypto</p>

      <show-accounts :accountDetails="accountDetails" />

      <div class="unprivileged" v-if="!manageAccess.accountDetails">
        <b>A/C Details</b>
        <i class="fa fa-lock" />
        <strong>
          Access Denied
          <i class="fa fa-info-circle">
            <md-tooltip md-direction="top">Please contact your admin to get access to this section</md-tooltip>
          </i>
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import ShowAccounts from '@/components/AccountSummary/ShowAccounts'

import ApiServices from '@/services/api/accountStatement'
import { amountFormat, openPopup } from '@/utils/helpers'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AccountDetails',
  components: { ShowAccounts },
  props: {
    accountDetails: Array,
    manageAccess: Object,
    loader: Boolean,
    selfVa: Object,
    lienAmount: Number
  },
  computed: {
    ...mapGetters(['getterAccountBalance'])
  },
  filters: {
    verifyText (manageAccess) {
      if (manageAccess.bankVerify && manageAccess.upiVerify) {
        return 'Bank & UPI Verification'
      } else if (manageAccess.bankVerify) {
        return 'Bank Verification'
      } else {
        return 'UPI Verification'
      }
    }
  },
  methods: {
    amountFormat,
    openPopup,
    ...mapMutations(['SET_CONNECTED_BANK_BALANCE']),
    connectedBankBalance () {
      ApiServices.connectedBankBalance().then(response => {
        const data = response.data
        if (data) {
          this.SET_CONNECTED_BANK_BALANCE(data.balance)
          this.openPopup('ConnectedBankBalance')
        } else {
          this.errorToastMsg(response.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .account-details {
    margin-bottom: 20px;

    .top-panel {
      padding: 15px;
      flex: 1;
      position: relative;

      box-shadow: 0px 5px 60px rgba(101, 109, 113, 0.1), 10px 30px 20px rgba(101, 109, 113, 0.1);
      background: $white;
      border-radius: 15px;
      min-height: 150px;

      p {
        @include normal-text($grey-2, 15px);

        &.centered {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .fa-lock {
        color: $primary;
      }
    }

    .balance {
      @extend .top-panel;
      @include custom-flex(space-between, '', column);

      h6 {
        @include normal-text($secondary, 26px, bold);
      }
      strong {
        @include normal-text($secondary, 15px, 600);
        display: block;
        text-align: center;
      }

      .main-row {
        display: flex;
        grid-gap: 30px;

        .main-bal {
          .fa-info-circle {
            color: rgba(101, 109, 113, .5);
            margin-left: 5px;
          }

          p {
            margin-bottom: 20px;
          }

          .info {
            display: flex;
            align-items: center;
            margin: 8px 0 18px;

            .fa-lock {
              margin-right: 10px;
            }
          }
        }
      }

      .options {
        button {
          border-radius: 5px;
          padding: 10px 20px;
          white-space: nowrap;

          .fa {
            margin-right: 5px;
          }
        }
      }
    }

    .details {
      @extend .top-panel;

      p {
        margin-bottom: 10px;
      }

      .unprivileged {
        display: flex;
        align-items: center;
        margin-top: 10px;

        b {
          min-width: 120px;
          text-align: left;
          @include normal-text($grey-2, 14px, normal);
        }

        .fa-lock {
          margin-right: 10px;
        }

        .fa-info-circle {
          margin-left: 10px;
          color: rgba(101, 109, 113, .5);
          cursor: pointer;
        }
      }
    }
  }

  .desktop {
    .account-details {
      @include custom-flex(space-between, '');
      gap: 20px;

      .top-panel {
        padding: 25px;

        p {
          text-align: left;
        }
      }

      .balance {
        h6 {
          text-align: left;
        }

        i {
          cursor: pointer;
        }

        .options {
          @include custom-flex(flex-end, null);
          gap: 10px;

          button {
            font-size: 14px;
            font-weight: bold;
            min-width: 120px;

            &.connected-bank {
              position: absolute;
              top: 25px;
              right: 25px;
            }
          }
        }
      }

      .details {
        p {
          margin-bottom: 20px;
        }
      }
    }
  }

  .mobile, .tablet {
    .account-details {
      @include custom-flex('', '', column);

      .balance {
        margin-bottom: 10px;

        .main-row {
          flex-direction: column;
          justify-content: center;
          gap: 10px;

          .info {
            justify-content: center;
          }
        }

        h6 {
          margin: 10px 0 30px;
          font-size: 30px;
        }

        .options {
          @include custom-flex(center, center, column);
          gap: 5px 8px;

          button {
            flex: 1;
            width: 100%;
            max-width: 300px;
            margin: 2px;
            font-size: 14px;

            &.xl {
              flex: 2 !important;
            }
          }
        }
      }

      .details {
        z-index: 5;

        p {
          text-align: left;
        }
      }
    }
  }
</style>
